import { apolloClient } from "@td/ui";
import PROVIDERS_SEARCH_QUERY from "../queries/providers-search.graphql";
import { map } from "lodash";

export const loadProviders = async (params, limit = 10) => {
  const { data } = await apolloClient.query({
    query: PROVIDERS_SEARCH_QUERY,
    variables: {
      params,
      first: limit,
    },
    fetchPolicy: "network-only",
  });

  return map(data.providerBasicSearch.edges, "node");
};

export default loadProviders;
